const constObject = {
  BASE_URL: process.env.BASE_URL,
  ENV: process.env.NODE_ENV,
};
const constKeys = Object.keys(constObject);
const constList = constKeys.map(cn => ({
  name: cn,
  cn: constObject[cn],
}));
export default { arr: constList, obj: constObject };
